/**
 * axios基础构建
 * @date 2019-12-24
 */

import instance from './intercept';
import { AxiosRequest, CustomResponse } from './types';
import { ElMessage } from 'element-plus';
let Cryptojs = require('crypto-js'); // 引入AES源码js
import Constants from '../Constants';
import {getLocalStorage} from  '../storage'



class Abstract {
    protected baseURL = Constants.ApiUrl;
    protected headers: object = {
    'Content-Type': 'application/json;charset=UTF-8'
    };

    private apiAxios({ baseURL = this.baseURL, headers = this.headers, method, url, data, params, responseType,isAgency,cancelToken }: any): Promise<CustomResponse> {
        let client_id = Constants.clientId;
        // 代理请求
        if(isAgency){
            baseURL = Constants.AgentApiUrl;
            data = data ? this.buildPostParams(data) : '';
            client_id = this.encrypt(Constants.clientId)
        }

        Object.assign(headers, {
            'client_id': client_id,
        });

        if(getLocalStorage('accountid')){
            Object.assign(headers, {
                'accountid':  getLocalStorage('accountid'),
             });
        }

        if(getLocalStorage('access_token')){
            Object.assign(headers, {
                'access_token':  getLocalStorage('access_token'),
            });
        }
        return new Promise((resolve, reject) => {
            instance({
                baseURL,
                headers,
                method,
                url,
                params,
                data,
                responseType,
                cancelToken
            }).then((res) => {
                // resolve( res.data);
                /*200:服务端业务处理正常结束*/
                if (res.status === 200) {
                    resolve({ status: true,data: res.data });
                } else {
                    resolve({ status: false, data: res.data});
                }
            }).catch((err) => {
                const message = err?.data?.Errmsg;
                console.log(message,'message')
                if(message != '无效的凭据'){
                    ElMessage({ message });
                }
                reject({ status: false, data: null});
            });
        });
    }

    /**
     * GET类型的网络请求
     */
    protected getReq(config: any): Promise<CustomResponse> {
        return this.apiAxios({ ...config, method: 'GET' });
    }

    /**
     * POST类型的网络请求
     */
    protected postReq({ baseURL, headers, url, data, params, responseType}: AxiosRequest) {
        return this.apiAxios({ baseURL, headers, method: 'POST', url, data, params, responseType });
    }


    /**
     * POST类型的网络请求  代理
     */
    protected postAgencyReq({ baseURL, headers = {}, url, data , params, responseType,isAgency = true}: AxiosRequest) {
        return this.apiAxios({ baseURL, headers, method: 'POST', url, data, params, responseType,isAgency });
    }


    // body 参数处理
    private buildPostParams(params : any){
        // let paramsArray = new  Array();
        // Object.keys(params).forEach((key) => {
        //     //console.log(params[key] instanceof Object);
        //     if(params[key] instanceof Array){
        //         params[key].forEach((val: any)=>{
        //             paramsArray.push(key+'['+params[key].indexOf(val)+']'+'=' + encodeURIComponent(val));
        //         });
        //     }else if(params[key] instanceof Object){
        //         Object.keys(params[key]).forEach((keys) => {
        //             paramsArray.push(key+'['+keys+']'+'=' + encodeURIComponent(params[key][keys]));
        //         })
        //     }else{
        //         paramsArray.push(key + '=' + encodeURIComponent(params[key]));
        //     }
        // });
        // params = paramsArray.join("&");
        return params;
    }


    //JS加密
    private encrypt (clientId: any) {
        let CryptoJS= Cryptojs;
        let data = clientId + '--' + this.convertDate(new Date());
        let key = CryptoJS.enc.Utf8.parse('607490BE-18CA-43D7-B11A-57E2621B');
        let iv = CryptoJS.enc.Utf8.parse('2D59831C-78AC-4227-B3F3-CE656636');
        let encrypted = CryptoJS.AES.encrypt(data, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
         return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };


    //JS加密
    private convertDate = function(date: any) {
        let res = date.getFullYear() + ',' + (date.getMonth() + 1) + ',' + date.getDate() + ',' + date.getHours() + ',' + date.getMinutes() + ',' + date.getSeconds();
        return res;
    };


    /**
     * PUT类型的网络请求
     */
    protected putReq({ baseURL, headers, url, data, params, responseType }: AxiosRequest) {
        return this.apiAxios({ baseURL, headers, method: 'PUT', url, data, params, responseType });
    }

    /**
     * DELETE类型的网络请求
     */
    protected deleteReq({ baseURL, headers, url, data, params, responseType }: AxiosRequest) {
        return this.apiAxios({ baseURL, headers, method: 'DELETE', url, data, params, responseType });
    }
}

export default Abstract;
